import { makeAutoObservable } from 'mobx'
import { ResultFrame } from '../Frame'
import { FrameInfo, WindowAnalyze } from '@entities/video'

export class VideoInfoStore {
	static #instance: VideoInfoStore
	public video: File | null = null
	public isVideoLoading: boolean = false
	public isCaptured: boolean = false
	public recommendations: WindowAnalyze[] = []
	public replayCounter: number = 0
	public framesDelayTime: number = -1
	private frames_: string[] = []
	private videoFrameData_: ResultFrame[] = []

	private constructor() {
		makeAutoObservable(this)
	}

	public static get instance(): VideoInfoStore {
		if (!this.#instance) {
			this.#instance = new VideoInfoStore()
		}
		return this.#instance
	}

	public get framesToShow() {
		const result: { frame: string; frameData: ResultFrame }[] = []
		for (let i = 0; i < Math.min(this.frames_.length, this.videoFrameData_.length); i++) {
			result.push({ frame: this.frames_[i], frameData: this.videoFrameData_[i] })
		}
		return result
	}

	public setVideoOverlay = async (overlays: Record<string, FrameInfo>) => {
		Object.values(overlays).forEach(overlay => {
			this.videoFrameData_.push({ metrics: overlay.metrics })
		})
	}

	public setUpFrames = async (video: File) => {
		this.video = video
		const framesAmount: number = this.videoFrameData_.length

		const videoElement = document.createElement('video')
		videoElement.src = URL.createObjectURL(video)
		videoElement.muted = true
		videoElement.preload = 'metadata'

		await new Promise<void>(resolve => {
			videoElement.onloadedmetadata = () => {
				resolve()
			}
		})

		const duration: number = videoElement.duration
		this.framesDelayTime = duration / framesAmount

		const frames: string[] = []

		for (let i = 0; i < framesAmount; i++) {
			console.log(i)
			const time = i * this.framesDelayTime
			await new Promise<void>(resolve => {
				videoElement.currentTime = time
				videoElement.onseeked = () => {
					const canvas = document.createElement('canvas')
					canvas.width = videoElement.videoWidth
					canvas.height = videoElement.videoHeight
					const ctx = canvas.getContext('2d')
					if (ctx) {
						ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height)
						const base64: string = canvas.toDataURL('image/jpeg')
						frames.push(base64)
					}
					resolve()
				}
			})
		}

		this.frames_ = frames
	}

	public reset = () => {
		this.video = null
		this.isVideoLoading = false
		this.isCaptured = false
		this.recommendations = []
		this.replayCounter = 0
		this.framesDelayTime = -1
		this.frames_ = []
		this.videoFrameData_ = []
	}
}
